module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row max-height-vertical box-overflow"
  }, [_c('div', {
    staticClass: "row scroll-outer"
  }, [_c('div', {
    staticClass: "span-14-lg offset-1-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('p', {
    staticClass: "large",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _vm._l((_vm.content.paragraphs), function(paragraph, index) {
    return _c('div', {
      key: index,
      staticClass: "relative span-6-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs bg-white share-flip-outer no-ratio-md",
      class: _vm.lg_offset(index),
      style: (_vm.ratio_styles),
      attrs: {
        "container-card": "share-card"
      }
    }, [_c('div', {
      staticClass: "scroll-outer"
    }, [_c('div', {
      staticClass: "share-flip-inner"
    }, [_c('p', [_vm._v(_vm._s(paragraph))]), _vm._v(" "), _c('div', {
      staticClass: "share-button-container"
    }, [_c('nav-button', {
      attrs: {
        "type": "share"
      }
    }, [_vm._v("share")])], 1)])])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbc1e03e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/pages/share_page.vue
// module id = 664
// module chunks = 1